import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {ref, watch, computed} from "vue"
import SpeedAlertSubSetting from "@/components/VehicleFormParts/SpeedAlertSubSetting.vue";
import SpeedAlertSubPreSetting from "@/components/VehicleFormParts/SpeedAlertSubPreSetting.vue";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'IniFileSpeedAlertSetting',
  props: {
    modelValue: {},
    formInputs: {},
    selectDefault: { type: Boolean, default: false },
    errors: {},
    isInstallationOffice: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit;

const readonlyInputs = ref<any[]>([]);

const form = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

watch(() => props.formInputs, () => {
  if (!props.formInputs?.form?.speed_alert) {
    return;
  }
  const key = Object.keys(props.formInputs.default_params)[0];
  readonlyInputs.value = Object.keys(props.formInputs.default_params[key]?.parameters?.speed_alert ?? []);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (!!__props.formInputs?.form?.speed_alert)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "my-4 pa-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_subtitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicles.form.iniFileSetting.speedAlert.subtitle')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(SpeedAlertSubSetting, {
                modelValue: form.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
                selectDefault: __props.selectDefault,
                errors: __props.errors,
                formInputs: __props.formInputs,
                operationOfficeId: null,
                deviceId: null,
                isInstallationOffice: __props.isInstallationOffice
              }, null, 8, ["modelValue", "selectDefault", "errors", "formInputs", "isInstallationOffice"]),
              _createVNode(SpeedAlertSubPreSetting, {
                modelValue: form.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form).value = $event)),
                selectDefault: __props.selectDefault,
                errors: __props.errors,
                formInputs: __props.formInputs,
                operationOfficeId: null,
                deviceId: null,
                isInstallationOffice: __props.isInstallationOffice
              }, null, 8, ["modelValue", "selectDefault", "errors", "formInputs", "isInstallationOffice"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})